import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SizeModifierSelect = ({
    className,
    currentSizeId,
    options,
    onChange,
}) => {
    const [t] = useTranslation('product-editor');

    const onSizeChange = useCallback(
        e => {
            onChange(e.target.value);
        },
        [onChange]
    );

    return (
        <select
            data-size
            className={className}
            value={currentSizeId}
            onChange={onSizeChange}
        >
            {options
                .filter(({ visible }) => visible)
                .map(({ id, name, price, out_of_stock }) => (
                    <option value={id} key={id} disabled={out_of_stock}>
                        {name} –{' '}
                        {t('common:price', {
                            price,
                        })}
                        {out_of_stock && ` - ${t('sold_out')}`}
                    </option>
                ))}
        </select>
    );
};

SizeModifierSelect.propTypes = {
    className: PropTypes.string.isRequired,
    currentSizeId: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            price: PropTypes.object,
            out_of_stock: PropTypes.bool,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default SizeModifierSelect;
